import generalApi from '@/api/generalApi.js'
/*import sanitizeTitle from '@/modules/codigo/helpers/slug.js'*/

export const setCodigos = async ({ commit }) => {
    const data = await generalApi.get('/v1/codigos/listado')
    commit('mutCodigos', data.data)
    return data.data
}


// updateCodigo
// createCodigo


export const selectCodigo = async ({ commit }, id) => {
    commit('selectCodigo', id)
}

export const updateCodigo = async ({ commit }, dato) => {
    try {
        const { codigo, cedula } = dato[0]
        const carrera_id = dato[1]
        const id = dato[2]
        const dataToSave = { id, codigo, cedula, carrera_id }
        const resp = await generalApi.put(`/v1/codigos/${id}`, dataToSave)
        return resp
    } catch (error) {
        return error.response.data
    }
}
export const createCodigo = async ({ commit }, dato) => {
    try {
        const { codigo, cedula } = dato[0]
        const carrera_id = dato[1]
        const dataToSave = { codigo, cedula, carrera_id }
        const resp = await generalApi.post(`/v1/codigos/register`, dataToSave)
        return resp.data
    } catch (error) {
        return error.response.data
    }
}
export const deleteCodigo = async ({ commit }, id) => {
    try{
        const del = await generalApi.delete(`/v1/codigos/${id}`)
        commit('delcodigo', id)
        return del.data
    } catch (error) {
        return error.response.data
    }

}
